import React, { useEffect, useState } from 'react';
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import db from "../../../../api/mongodb";
import "./BestPracticeForm.scss";
import { defaultOptions1 } from "../../../../config/loading-config.js";
import Lottie from "react-lottie";
import SafeDesignLogo from "../../../../images/safe-logo.png"
import { useWindowSize } from '@uidotdev/usehooks';
import { Box } from '@mui/material';
import { compressBase64 } from '../../../../utils/utils';
import { useNavigate, useParams } from 'react-router-dom';



const BestPracticeForm = () => {


    const [surveyModel, setSurveyModel] = useState(new Model({}));
    const [isLoading, setIsLoading] = useState(true)

    const [show, setShow] = useState(false);
    const [showFail, setShowFail] = useState(false);
    const [surveyResult, setSurveyResult] = useState({});

    const navigate = useNavigate()
    let { id } = useParams();

    

    const { width, height } = useWindowSize()

    useEffect(() => {
        createSurvey();
    }, []);


    useEffect(() => {
        // this controls the dialog boxes
        if (show) {
            //reset the survey with the old data 
            surveyModel.clear()
            surveyModel.data = surveyResult
            setTimeout(() => {
                setShow(false);
            }, 3000);
        }
    }, [show]);

    useEffect(() => {
        //this controls the dialog boxes
        if (showFail) {
            //reset the survey with the old data 
            surveyModel.clear()
            surveyModel.data = surveyResult
            setTimeout(() => {
                setShowFail(false);
            }, 3000);


        }
    }, [showFail]);

    const createSurvey = () => {
        // Survey.StylesManager.applyTheme("modern");
        // StylesManager.applyTheme("modern");

        db.get("/api/propertyAssessments/querySurvey").then(
            (query) => {
                db.get("/api/bestPractices/getTemplates").then(
                    (response) => {
                        // console.log(query)

                        // console.log(response)
                        // var template = response.data[0].surveyTemplate;
                        var template = response.data[0].surveyTemplate;
                        // template.elements[0].elements[1].columns[0].choices = choices;

                        // const survey = new Survey.Model(template);
                        const survey = new Model(template);

                        // survey.showNavigationButtons = false;
                        survey.completedHtml = "<h3>Saving Best Practice...</h3>";
                        // survey.showCompletedPage = false;
                        survey.showPreviewBeforeComplete = "showAnsweredQuestions"

                        

                        

                        // survey.onServerValidateQuestions.add((sender, options) => {
                        //   options.errors["email"] = "Country is not found";
                        // });

                        // survey.onComplete.add((sender, options) => {
                        //     console.log(JSON.stringify(sender.data, null, 3));
                        // });

                        // eslint-disable-next-line no-undef
                        var converter = new showdown.Converter({
                            openLinksInNewWindow: true
                        })

                        // eslint-disable-next-line no-undef
                        var defaultOptions = showdown.getDefaultOptions();

                        // console.log(defaultOptions)
                        // console.log(converter)

                        survey.onTextMarkdown.add((survey, options) => {
                            var str = converter.makeHtml(options.text);
                            //remove root paragraphs <p></p>
                            str = str.substring(3);
                            str = str.substring(0, str.length - 4);
                            //set html
                            options.html = str;
                        })


                        survey.onValueChanged.add(function (sender, options) {
                            
                            if (options.name === "section") {
                                var subSectionQuestion = survey.getQuestionByName("sub_section")
                                var subSectionQuestionValue = [...subSectionQuestion.value]
                                var tempValues = []


                                // subSectionQuestion.value=[]
                                subSectionQuestion.choices = []
                                var subSectionChoices = []
                                for (var i = 0; i < query.data.length; i++) {
                                    var section = query.data[i]
                                    if (options.value.includes(section.id)) {

                                        for (var j = 0; j < section.subsections.length; j++) {
                                            var subsection = section.subsections[j]
                                            subSectionChoices.push({ text: subsection["name"], value: subsection["id"] })
                                            if (subSectionQuestionValue.includes(subsection["id"])) {

                                                tempValues.push(subsection['id'])
                                            }
                                        }
                                    }

                                    // console.log(section)
                                }
                                // console.log(subSectionChoices)
                                // console.log(survey.getQuestionByName("sub_section").value )

                                subSectionQuestion.value = tempValues
                                subSectionQuestion.choices = subSectionChoices
                            }

                            if (options.name === "sub_section") {



                                var performanceMeasureQuestion = survey.getQuestionByName("performance_measure")
                                var performanceMeasureQuestionValue = [...performanceMeasureQuestion.value]

                                // console.log(performanceMeasureQuestionValue)

                                var tempValues2 = []
                                // performanceMeasureQuestion.value=[]
                                performanceMeasureQuestion.choices = []

                                var performancMeasuresChoices = []
                                for (i = 0; i < query.data.length; i++) {
                                    section = query.data[i]


                                    for (j = 0; j < section.subsections.length; j++) {
                                        subsection = section.subsections[j]
                                        if (options.value.includes(subsection.id)) {
                                            for (var k = 0; k < subsection.performanceMeasure.length; k++) {
                                                var performance_measure = subsection.performanceMeasure[k]
                                                // console.log(performance_measure)
                                                performancMeasuresChoices.push({ text: performance_measure["name"], value: performance_measure["id"] })
                                                if (performanceMeasureQuestionValue.includes(performance_measure["id"])) {
                                                    tempValues2.push(performance_measure['id'])
                                                }
                                            }
                                        }

                                    }


                                    // console.log(section)
                                }
                                // console.log(performancMeasuresChoices)
                                performanceMeasureQuestion.value = [...tempValues2]
                                performanceMeasureQuestion.choices = performancMeasuresChoices
                            }






                        });

                        if(id){
                            db.get(`/api/bestPractices/getOne/${id}`)
                            .then((data)=>{
                                survey.getQuestionByName("section").value=data.data.formData.section
                                survey.getQuestionByName("sub_section").value=data.data.formData.sub_section
                                survey.data= data.data.formData
                                // console.log("hello")
                                
                            })
                            .catch((err)=>{

                            })
                        }

                        survey.onComplete.add(async (sender, options) => {
                            //store the survey data in the state vairiable
                            setSurveyResult(sender.data);

                            var tempData = JSON.parse(JSON.stringify(sender.data))

                            // compressing all the images
                            if (tempData.images && tempData.images.length > 0) {
                                //loop through the images object
                                for (var i = 0; i < tempData.images.length; i++) {
                                    var image = tempData.images[i].image
                                    //loop through the actual images since it can be a list as well
                                    if (image && image.length > 0) {
                                        for (var j = 0; j < image.length; j++) {
                                            //replace the content with the compressed base 64
                                            tempData.images[i].image[j].content = await compressBase64(image[j].content)
                                        }
                                    }
                                }
                            }
                            if(id){
                                db.put(`/api/bestPractices/edit/${id}`,{formData: tempData})
                                .then((result) => {
                                    //show success popup
                                    setShow(true)
                                },
                                    (error) => {
                                        //show failure popup
                                        setShowFail(true)
                                    })
                                .catch((error) => {
                                    //show failure popup
                                    setShowFail(true)
                                }) 
                            }else{
                                db.post("/api/bestPractices/createBestPractice",{formData: tempData})
                                .then((result) => {
                                    //show success popup
                                    setShow(true)
                                },
                                    (error) => {
                                        //show failure popup
                                        setShowFail(true)
                                    })
                                .catch((error) => {
                                    //show failure popup
                                    setShowFail(true)
                                })
                            }
                            


                            console.log(tempData)

                        })


                        setSurveyModel(survey);
                        setIsLoading(false);
                    },
                    (error) => { 
                        // navigate("/")

                    }
                )
                .catch((err)=>{
                    navigate("/projects/active")
                })
            },
            (error) => { }
        )



    };

    if (isLoading) {
        return <Lottie options={defaultOptions1} height={200} width={200} />;
    }
    return (
        //   background: linear-gradient(112.01deg, #112c54 -6.27%, #1a6dd1 120.83%);
        <div style={{ background: "linear-gradient(112.01deg, #112c54 -6.27%, #1a6dd1 120.83%)", minHeight: height, width: width }}>
            <a
                href={id?"/bestPracticeList":"/projects/active" }
                style={{
                    position: "relative",
                    left: "72%",
                    top: "45px",
                    color: "#FFF",
                    textDecoration: "none",
                }}
            >
                Back
            </a>
            <div className="registration-background">


                {show && (
                    <div
                        variant={"success"}
                        style={{
                            position: "fixed",
                            top: "7rem",
                            right: "1rem",
                            width: "15%",
                            textAlign: "center",
                            border: "1px solid #badbcc",
                            borderRadius: "0.375rem",
                            backgroundColor: "#d1e7dd",
                            color: "#0f5132",
                            padding: 20,
                            zIndex: `${show ? 1500 : 0}`,
                        }}
                    >
                        Best Practice successfully saved!
                    </div>
                )}
                {showFail && (
                    <div
                        variant="error"
                        style={{
                            position: "fixed",
                            top: "7rem",
                            right: "1rem",
                            width: "15%",
                            textAlign: "center",
                            border: "1px solid #badbcc",
                            borderRadius: "0.375rem",
                            backgroundColor: "#fdeded",
                            color: "#6c3231",
                            padding: 20,
                            zIndex: `${showFail ? 1500 : 0}`,
                        }}
                    >
                        Best Practice could not be saved, maybe try reducing the amount of data and please try again
                    </div>
                )}


                <div className="registration-card" style={{ paddingTop: "20px" }}>
                    <img src={SafeDesignLogo} className='titleLogo' alt="logo" style={{ width: "120px", height: "44px" }} />
                    <Survey model={surveyModel} />
                </div>


                {/* <p
                    style={{
                        color: "#FFF",
                        textAlign: "center",
                        position: "relative",
                        top: 30,
                        background:"linear-gradient(112.01deg, #112c54 -6.27%, #1a6dd1 120.83%)"
                    }}
                >
                    © Copyright {new Date().getFullYear()} SAFE DESIGN Software
                </p> */}
            </div>
        </div>
    );
};





export default BestPracticeForm;